import React from "react";
import { useAssessments } from "../context/assessment-provider";
import {
  GrowbotAdult,
  GrowbotYoungFlower,
  GrowbotYoungLeaf,
  GrowbotAdultShadow,
  GrowbotYoungFlowerShadow,
  GrowbotYoungLeafShadow
} from "./svgs";
import "./growbot.scss";

interface IGrowbotProps {
  botstyle: string;
  className?: string;
}
function Growbot({ botstyle, className }: IGrowbotProps) {
  const { grade } = useAssessments();
  if ((grade ?? 0) > 2) {
    return (
      <div className={`growbot-container ${className ?? ""}`}>
        <GrowbotAdult alt="Decorative monster" className="monster-image" />
        <GrowbotAdultShadow alt="Monster shadow" className="monster-shadow" />
      </div>
    );
  }

  if (botstyle === "leaf") {
    return (
      <div className={`growbot-container ${className ?? ""}`}>
        <GrowbotYoungLeaf alt="Decorative monster" className="monster-image" />
        <GrowbotYoungLeafShadow alt="Monster shadow" className="monster-shadow" />
      </div>
    );
  }

  return (
    <div className={`growbot-container  ${className ?? ""}`}>
      <GrowbotYoungFlower alt="Decorative monster" className="monster-image" />
      <GrowbotYoungFlowerShadow alt="Monster shadow" className="monster-shadow" />
    </div>
  );
}

export default Growbot;
